// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn-nbia-default, .btn-nbia-i-cart, .btn-nbia-i-default, .btn-nbia-li-default {
  border: solid #cccccc 1px;
  background-color: #ffffff;
  height: calc(32px + 2px);
  outline: none;
  user-select: none;
  box-shadow: none !important;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}

.btn-nbia-default:hover, .btn-nbia-i-cart:hover, .btn-nbia-i-default:hover, .btn-nbia-li-default:hover {
  border: solid #adadad 1px;
  background-color: #e6e6e6;
}

.btn-nbia-default:disabled, .btn-nbia-i-cart:disabled, .btn-nbia-i-default:disabled, .btn-nbia-li-default:disabled {
  border: solid #d3d2d2 1px;
  background-color: #f4f3f3;
}

.btn-nbia-li-default {
  /* T R B L */
  padding: 0px 7px 1px 7px;
  margin: 0 7px 0 7px;
  max-height: 45px;
}

.btn-nbia-i-default {
  /* T R B L */
  padding: 2px 7px 1px 7px;
  margin: 0 7px 0 7px;
  max-width: 30px;
  max-height: 25px;
}

.btn:disabled {
  cursor: not-allowed;
}

.btn-nbia-i-cart {
  /* T R B L */
  padding: 2px 7px 1px 7px;
  margin: 0 7px 0 7px;
  max-width: 30px;
  max-height: 25px;
}

.btn-nbia-i-cart:hover {
  background-color: lightcoral;
}

.card-nbia-header, .card-nbia-header-default, .card-nbia-header-with-icon, .card-nbia-header-with-icon-default, .card-nbia-header-danger {
  padding-bottom: 0;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
}

.card-nbia-header-with-icon, .card-nbia-header-with-icon-default, .card-nbia-header-danger {
  height: 58px;
}

.card-nbia-header-danger {
  background-color: #f2dede;
  color: #a94442;
  border-bottom: solid #ebccd1 1px;
}

.card-nbia-danger {
  border-color: #ebccd1;
  border-radius: 3px;
}

.card-nbia-header-default {
  height: 43px;
  background-color: #d9edf7;
  color: #347391;
  border-color: #bce8f1;
  border-bottom: solid #bce8f1 1px;
}

.card-nbia-header-with-icon-default {
  background-color: #d9edf7;
  color: #347391;
  border-color: #bce8f1;
  border-bottom: solid #bce8f1 1px;
}

.card-nbia-default {
  border-color: #bce8f1;
  border-radius: 3px;
}

/* Space between menu bar and top of content */
.dark-row {
  background-color: #f4f4f4;
}

.cart-child-selected {
  background-color: #ff7 !important;
}

.redCart {
  background-color: lightcoral;
}

.greenCart, .cart-selected {
  background-color: aquamarine !important;
}

/* Cart button on Cart screen */
.cart-button {
  padding: 2px 7px 1px 7px;
  margin: 0 7px 0 7px;
}

/* Trying to clean this up for Chrome */
.no-outline, .nbia-button {
  outline: none;
}

.child-data-display {
  background-color: #fff;
  border: solid 1px #e7e7e7;
  /*  Show some parent background */
  margin: 8px 8px 16px 8px;
  /* Child display */
  padding: 6px;
  /*           h-offset   v-offset   blur    spread   color          */
  box-shadow: 6px 6px 12px 0 rgba(0, 0, 0, 0.2), 0 10px 24px 0 rgba(0, 0, 0, 0.15);
  border-radius: 5px;
}

.child-data-display-parent-background {
  background-color: #edf8fb;
}

/*  TODO  explain  */
.alert-box-div {
  z-index: 21;
  position: absolute;
  /* Set the vertical location of all the Alert/Message boxes.  */
  margin-top: 100px;
}

.alert-box-shadow {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.alert-box-button {
  float: right;
  margin-left: 4px;
}

.alert-box-icon {
  font-size: x-large;
}

.hide-item {
  display: none;
}

.nbia-loading-label {
  color: #fff;
  /*background-color: #00f8f8;*/
  font-size: 12pt;
}

/*Odd and even, but skipping the top row (Heading)*/
tr:nth-child(even) {
  background: #fff;
}

tr:nth-child(2n+3) {
  background: #f4f4f4;
}

.nbia-drop-down > li:nth-child(even) {
  background: #f4f4f4;
}

.nbia-drop-down > li:nth-child(2n+3) {
  background: #fff;
}

.nbia-drop-down {
  min-width: 60px;
}

.nbia-drop-down > li > a:hover {
  /*background: #baffff;*/
  background: #dde8eb;
}

.busy-pointer {
  cursor: wait;
}

.disabled-busy-check {
  color: #999;
  cursor: wait;
}

.disabled-check {
  color: #aaa;
  cursor: default;
}

.cart-td {
  width: 94px;
  border-left: none;
  margin-right: 0px;
  margin-left: 0px;
  padding-right: 0px;
  padding-left: 0px;
}

/* ********* Buttons ******** */
.nbia-button {
  color: #fff;
  background-color: #0b7983;
  cursor: pointer;
  /*
  font-size: 10pt;
  */
}

.nbia-button:hover {
  background-color: #277599;
}

.nbia-button:active {
  background-color: #1e5975;
}

.nbia-button-disabled:active {
  cursor: not-allowed;
  background-color: #70a4bd;
  color: #f5fafa;
}

.nbia-button-disabled:hover {
  cursor: not-allowed;
  background-color: #70a4bd;
}

.nbia-button-disabled {
  cursor: not-allowed;
  background-color: #70a4bd;
}

.clicker {
  cursor: pointer;
}

.search-results-cart-count {
  background-color: #5b5151;
  color: #fff;
  border-radius: 3px;
  padding: 3px 6px 3px 6px;
  /*margin-left: 2px;*/
  margin-left: -5px;
  margin-bottom: 2px;
  font-size: 8pt;
}

.thead-td {
  background-color: #dedddd;
  border: solid 1px #dedddd;
  height: 50px;
  font-weight: bold;
}

/* For first column headers that would otherwise but up against the left edge and look crowded  */
.thead-td1 {
  padding-left: 3px;
}

.footer-colors {
  color: #686868;
}

.number-spinner {
  border: solid 1px #686868;
  border-radius: 3px;
  position: relative;
  top: 0px;
  padding: 0 4px 0 4px;
  margin: 10px 2px 0 4px;
  width: 60px;
  height: 28px;
}

.rows-per-page-spinner {
  color: #686868;
  margin-bottom: 12px;
}

.popup-heading-text {
  font-size: 12pt;
  font-weight: bold;
}

.close-x {
  font-weight: bold;
  font-family: "Arial Black", Gadget, sans-serif;
  color: #800;
  float: right;
}

.unselectable {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
}

.application-menu-icon {
  width: 14px;
  height: 14px;
}

.cart-button-icon {
  width: 14px;
  height: 14px;
}

.cart-delete-button-icon {
  height: 20px;
  padding: 0 3px 1px 0;
}

.chevron-right-icon {
  height: 14px;
}

.chevron-down-icon {
  width: 14px;
}

.sort-triangle {
  height: 14px;
}`, "",{"version":3,"sources":["webpack://./src/app/btn-nbia.scss","webpack://./src/app/app.component.scss","webpack://./src/app/card-nbia.scss"],"names":[],"mappings":"AAWA;EACI,yBAAA;EACA,yBATuB;EAUvB,wBAAA;EAEA,aAAA;EACA,iBAAA;EACA,2BAAA;EACA,2BAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;ACXJ;;ADcA;EACI,yBAAA;EACA,yBAtB6B;ACWjC;;ADcA;EACI,yBAAA;EACA,yBA1BgC;ACepC;;ADeA;EAEI,YAAA;EACA,wBAAA;EACA,mBAAA;EACA,gBAAA;ACbJ;;ADiBA;EAEI,YAAA;EACA,wBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;ACfJ;;ADkBA;EACI,mBAAA;ACfJ;;ADqBA;EAEI,YAAA;EACA,wBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;ACnBJ;;ADsBA;EACI,4BAAA;ACnBJ;;ACvCA;EACI,iBAAA;EACA,2BAAA;EACA,4BAAA;AD0CJ;;ACtCA;EAEI,YArBgC;AD6DpC;;ACrCA;EAEI,yBAnBuC;EAoBvC,cAnBiC;EAoBjC,gCAAA;ADuCJ;;ACpCA;EACI,qBA1BmC;EA2BnC,kBAAA;ADuCJ;;ACnCA;EAEI,YAxCsB;EAyCtB,yBArCwC;EAsCxC,cArCkC;EAsClC,qBAxCoC;EAyCpC,gCAAA;ADqCJ;;AClCA;EAEI,yBA7CwC;EA8CxC,cA7CkC;EA8ClC,qBAhDoC;EAiDpC,gCAAA;ADoCJ;;ACjCA;EACI,qBArDoC;EAsDpC,kBAAA;ADoCJ;;AA1E6B,8CAAA;AAqC7B;EACI,yBAhDa;AAyFjB;;AAtCA;EACI,iCAAA;AAyCJ;;AAtCA;EACI,4BAAA;AAyCJ;;AAtCA;EACI,uCAAA;AAyCJ;;AAtCA,+BAAA;AACA;EACI,wBAAA;EACA,mBAAA;AAyCJ;;AArCA,uCAAA;AACA;EACI,aAAA;AAwCJ;;AArCA;EACI,sBAAA;EACA,yBAAA;EAEA,iCAAA;EACA,wBAAA;EAEA,kBAAA;EACA,YAAA;EAEA,oEAAA;EACA,gFAAA;EAGA,kBAAA;AAmCJ;;AAhCA;EACI,yBAAA;AAmCJ;;AAhCA,oBAAA;AACA;EACI,WA7EY;EA8EZ,kBAAA;EAEA,+DAAA;EACA,iBApGQ;AAsIZ;;AA/BA;EACI,4EAAA;AAkCJ;;AA/BA;EACI,YAAA;EACA,gBAAA;AAkCJ;;AA/BA;EACI,kBAAA;AAkCJ;;AA/BA;EACI,aAAA;AAkCJ;;AA/BA;EACI,WAAA;EACA,6BAAA;EACA,eAAA;AAkCJ;;AA/BA,mDAAA;AACA;EACI,gBAAA;AAkCJ;;AA/BA;EACI,mBAAA;AAkCJ;;AA/BA;EACI,mBAAA;AAkCJ;;AA/BA;EACI,gBAAA;AAkCJ;;AA/BA;EACI,eAAA;AAkCJ;;AA/BA;EACI,uBAAA;EACA,mBAAA;AAkCJ;;AA/BA;EACI,YAAA;AAkCJ;;AA/BA;EACI,WAAA;EACA,YAAA;AAkCJ;;AA/BA;EACI,WAAA;EACA,eAAA;AAkCJ;;AA/BA;EACI,WAAA;EAGA,iBAAA;EAGA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;AA8BJ;;AA1BA,+BAAA;AACA;EAEI,WAAA;EACA,yBAAA;EACA,eAAA;EACA;;GAAA;AA8BJ;;AAzBA;EACI,yBAAA;AA4BJ;;AAzBA;EACI,yBAAA;AA4BJ;;AAzBA;EACI,mBAAA;EACA,yBAAA;EACA,cAAA;AA4BJ;;AAzBA;EACI,mBAAA;EACA,yBAAA;AA4BJ;;AAzBA;EACI,mBAAA;EACA,yBAAA;AA4BJ;;AAxBA;EACI,eAAA;AA2BJ;;AAxBA;EACI,yBAAA;EACA,WAAA;EACA,kBAAA;EAEA,wBAAA;EACA,oBAAA;EACA,iBAAA;EAGA,kBAAA;EAEA,cAAA;AAuBJ;;AApBA;EACI,yBAAA;EACA,yBAAA;EACA,YAAA;EACA,iBAAA;AAuBJ;;AApBA,iGAAA;AACA;EACI,iBAAA;AAuBJ;;AApBA;EACI,cAAA;AAuBJ;;AApBA;EACI,yBAAA;EACA,kBAAA;EAEA,kBAAA;EACA,QAAA;EACA,oBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;AAsBJ;;AAnBA;EACI,cAAA;EACA,mBAAA;AAsBJ;;AAnBA;EACI,eAAA;EACA,iBAAA;AAsBJ;;AAnBA;EACI,iBAAA;EACA,8CAAA;EACA,WAlRU;EAmRV,YAAA;AAsBJ;;AAlBA;EACI,2BAAA;EACA,yBAAA;EAIA,iBAAA;AAqBJ;;AAjBA;EACI,WAAA;EACA,YAAA;AAoBJ;;AAhBA;EACI,WAAA;EACA,YAAA;AAmBJ;;AAhBA;EAEI,YAAA;EACA,oBAAA;AAkBJ;;AAdA;EACI,YAAA;AAiBJ;;AAdA;EACI,WAAA;AAiBJ;;AAdA;EACI,YAAA;AAiBJ","sourcesContent":["$default-border-color: #cccccc;\n$default-border-hover-color: #adadad;\n$default-border-disabled-color: #d3d2d2;\n\n$default-background-color: #ffffff;\n$default-background-hover-color: #e6e6e6;\n$default-background-disabled-color: #f4f3f3;\n\n$default-height: 32px;\n$default-border-line-width: 1px;\n\n.btn-nbia-default {\n    border: solid $default-border-color $default-border-line-width;\n    background-color: $default-background-color;\n    height: calc(#{$default-height} + #{$default-border-line-width * 2 });\n\n    outline: none;\n    user-select: none;\n    box-shadow: none !important;\n    -webkit-touch-callout: none;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n}\n\n.btn-nbia-default:hover {\n    border: solid $default-border-hover-color $default-border-line-width;\n    background-color: $default-background-hover-color;\n}\n\n.btn-nbia-default:disabled {\n    border: solid $default-border-disabled-color $default-border-line-width;\n    background-color: $default-background-disabled-color;\n}\n\n// For buttons with just a larger image/icon Cine mode\n.btn-nbia-li-default {\n    @extend .btn-nbia-default;\n    /* T R B L */\n    padding: 0px 7px 1px 7px;\n    margin: 0 7px 0 7px;\n    max-height: 45px;\n}\n\n// For buttons with just an image/icon\n.btn-nbia-i-default {\n    @extend .btn-nbia-default;\n    /* T R B L */\n    padding: 2px 7px 1px 7px;\n    margin: 0 7px 0 7px;\n    max-width: 30px;\n    max-height: 25px;\n}\n\n.btn:disabled{\n    cursor: not-allowed;\n}\n\n\n\n// This for the \"Cart\" page\n.btn-nbia-i-cart {\n    @extend .btn-nbia-default;\n    /* T R B L */\n    padding: 2px 7px 1px 7px;\n    margin: 0 7px 0 7px;\n    max-width: 30px;\n    max-height: 25px;\n}\n\n.btn-nbia-i-cart:hover {\n    background-color: lightcoral;\n}\n\n","@import './btn-nbia';\n@import './card-nbia';\n\n$left-section-width: 390px;\n\n$query-criteria-heading-text-color: #bb0e3d;\n$disabled-text: #747474;\n$button-down-background: #dedddd;\n\n$dark-row-color: #f4f4f4;\n\n$alert-top: 100px;\n\n$close-x-red: #800;\n\n// $heading-height: 110px;\n$heading-height: 122px;\n\n// FIXME This only is used for the opener/closer icon\n$heading-margin-bottom: 8px; /* Space between menu bar and top of content */\n\n$header-background-color: #013856;\n\n$legacy-feedback-left: 182px;\n\n$top-logo-height: 41px;\n\n$banner-font-size: 20pt;\n$display-query-top: 10px;\n\n$popup-z-index: 21;\n$loading-screen-z-index: 5;\n$tool-tip-z-index: 2;\n$display-query-z-index: 0; // @TODO explain\n$pie-char-description-popup-z-index: 2;\n$missing-criteria-z-index: 3;\n$search-results-column-selector-z-index: 2;\n$intro-z-index: 3;\n$banner-z-index: 6;\n\n\n%panel-heading-text-color {\n    color: $query-criteria-heading-text-color;\n}\n\n%panel-heading {\n    @extend %panel-heading-text-color;\n    background-color: #fff;\n    font-size: 12pt;\n}\n\n%left-section {\n    width: $left-section-width;\n}\n\n\n.dark-row {\n    background-color: $dark-row-color;\n}\n\n.cart-child-selected {\n    background-color: #ff7 !important;\n}\n\n.redCart {\n    background-color: lightcoral;\n}\n\n.greenCart, .cart-selected {\n    background-color: aquamarine !important;\n}\n\n/* Cart button on Cart screen */\n.cart-button {\n    padding: 2px 7px 1px 7px;\n    margin: 0 7px 0 7px;\n}\n\n\n/* Trying to clean this up for Chrome */\n.no-outline {\n    outline: none;\n}\n\n.child-data-display {\n    background-color: #fff;\n    border: solid 1px #e7e7e7;\n\n    /*  Show some parent background */\n    margin: 8px 8px 16px 8px;\n\n    /* Child display */\n    padding: 6px;\n\n    /*           h-offset   v-offset   blur    spread   color          */\n    box-shadow: 6px 6px 12px 0 rgba(0, 0, 0, 0.2),\n    0 10px 24px 0 rgba(0, 0, 0, 0.15);\n\n    border-radius: 5px;\n}\n\n.child-data-display-parent-background {\n    background-color: #edf8fb;\n}\n\n/*  TODO  explain  */\n.alert-box-div {\n    z-index: $popup-z-index;\n    position: absolute;\n\n    /* Set the vertical location of all the Alert/Message boxes.  */\n    margin-top: $alert-top;\n}\n\n.alert-box-shadow {\n    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n}\n\n.alert-box-button {\n    float: right;\n    margin-left: 4px;\n}\n\n.alert-box-icon {\n    font-size: x-large;\n}\n\n.hide-item {\n    display: none;\n}\n\n.nbia-loading-label {\n    color: #fff;\n    /*background-color: #00f8f8;*/\n    font-size: 12pt;\n}\n\n/*Odd and even, but skipping the top row (Heading)*/\ntr:nth-child(even) {\n    background: #fff\n}\n\ntr:nth-child(2n+3) {\n    background: #f4f4f4\n}\n\n.nbia-drop-down > li:nth-child(even) {\n    background: #f4f4f4;\n}\n\n.nbia-drop-down > li:nth-child(2n+3) {\n    background: #fff;\n}\n\n.nbia-drop-down {\n    min-width: 60px;\n}\n\n.nbia-drop-down > li > a:hover {\n    /*background: #baffff;*/\n    background: #dde8eb;\n}\n\n.busy-pointer {\n    cursor: wait;\n}\n\n.disabled-busy-check {\n    color: #999;\n    cursor: wait;\n}\n\n.disabled-check {\n    color: #aaa;\n    cursor: default;\n}\n\n.cart-td {\n    width: 94px;\n\n    //    border-color: #ff00dd;\n    border-left: none;\n\n\n    margin-right: 0px;\n    margin-left: 0px;\n    padding-right: 0px;\n    padding-left: 0px;\n\n}\n\n/* ********* Buttons ******** */\n.nbia-button {\n    @extend .no-outline;\n    color: #fff;\n    background-color: #0b7983;\n    cursor: pointer;\n    /*\n    font-size: 10pt;\n    */\n}\n\n.nbia-button:hover {\n    background-color: #277599;\n}\n\n.nbia-button:active {\n    background-color: #1e5975;\n}\n\n.nbia-button-disabled:active {\n    cursor: not-allowed;\n    background-color: #70a4bd;\n    color: #f5fafa;\n}\n\n.nbia-button-disabled:hover {\n    cursor: not-allowed;\n    background-color: #70a4bd;\n}\n\n.nbia-button-disabled {\n    cursor: not-allowed;\n    background-color: #70a4bd;\n}\n\n\n.clicker {\n    cursor: pointer;\n}\n\n.search-results-cart-count {\n    background-color: #5b5151;\n    color: #fff;\n    border-radius: 3px;\n\n    padding: 3px 6px 3px 6px;\n    /*margin-left: 2px;*/\n    margin-left: -5px;\n    //  margin-right: -25px;\n\n    margin-bottom: 2px;\n\n    font-size: 8pt;\n}\n\n.thead-td {\n    background-color: #dedddd;\n    border: solid 1px #dedddd;\n    height: 50px;\n    font-weight: bold;\n}\n\n/* For first column headers that would otherwise but up against the left edge and look crowded  */\n.thead-td1 {\n    padding-left: 3px;\n}\n\n.footer-colors {\n    color: #686868;\n}\n\n.number-spinner {\n    border: solid 1px #686868;\n    border-radius: 3px;\n\n    position: relative;\n    top: 0px;\n    padding: 0 4px 0 4px;\n    margin: 10px 2px 0 4px;\n    width: 60px;\n    height: 28px;\n}\n\n.rows-per-page-spinner {\n    color: #686868;\n    margin-bottom: 12px;\n}\n\n.popup-heading-text {\n    font-size: 12pt;\n    font-weight: bold;\n}\n\n.close-x {\n    font-weight: bold;\n    font-family: \"Arial Black\", Gadget, sans-serif;\n    color: $close-x-red;\n    float: right;\n}\n\n\n.unselectable {\n    -webkit-touch-callout: none;\n    -webkit-user-select: none;\n    -khtml-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n}\n\n\n.application-menu-icon{\n    width: 14px;\n    height: 14px;\n}\n\n\n.cart-button-icon{\n    width: 14px;\n    height: 14px;\n}\n\n.cart-delete-button-icon{\n    // width: 14px;\n    height: 20px;\n    padding: 0 3px 1px 0;\n}\n\n\n.chevron-right-icon{\n    height: 14px;\n}\n\n.chevron-down-icon{\n    width: 14px;\n}\n\n.sort-triangle{\n    height: 14px;\n}\n","$card-nbia-header-height: 43px;\n$card-nbia-header-with-icon-height: 58px;\n\n$card-nbia-header-default-border-color: #bce8f1;\n$card-nbia-header-default-background-color: #d9edf7;\n$card-nbia-header-default-text-color: #347391;\n\n$card-nbia-header-danger-border-color: #ebccd1;\n$card-nbia-header-danger-background-color: #f2dede;\n$card-nbia-header-danger-text-color: #a94442;\n\n\n// Abstract\n.card-nbia-header {\n    padding-bottom: 0;\n    border-top-left-radius : 3px;\n    border-top-right-radius : 3px;\n}\n\n// Abstract\n.card-nbia-header-with-icon {\n    @extend .card-nbia-header;\n    height:  $card-nbia-header-with-icon-height;\n}\n\n.card-nbia-header-danger{\n    @extend .card-nbia-header-with-icon;\n    background-color: $card-nbia-header-danger-background-color;\n    color: $card-nbia-header-danger-text-color;\n    border-bottom: solid $card-nbia-header-danger-border-color 1px;\n}\n\n.card-nbia-danger{\n    border-color: $card-nbia-header-danger-border-color;\n    border-radius : 3px;\n}\n\n\n.card-nbia-header-default{\n    @extend .card-nbia-header;\n    height:  $card-nbia-header-height;\n    background-color: $card-nbia-header-default-background-color;\n    color: $card-nbia-header-default-text-color;\n    border-color: $card-nbia-header-default-border-color;\n    border-bottom: solid $card-nbia-header-default-border-color 1px;\n}\n\n.card-nbia-header-with-icon-default{\n    @extend .card-nbia-header-with-icon;\n    background-color: $card-nbia-header-default-background-color;\n    color: $card-nbia-header-default-text-color;\n    border-color: $card-nbia-header-default-border-color;\n    border-bottom: solid $card-nbia-header-default-border-color 1px;\n}\n\n.card-nbia-default{\n    border-color: $card-nbia-header-default-border-color;\n    border-radius : 3px;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
